enum TextInputType {
    TEXT = 'text',
    PASSWORD = 'password',
    NUMBER = 'number'
}

export default TextInputType;